import styles from './WChanceCardHeader.module.scss';
import { montserrat } from '@/lib/font';

function WChanceCardHeader({
  showHeaderDescription = false,
}: {
  showHeaderDescription?: boolean;
}) {
  return (
    <>
      {showHeaderDescription && <div className={styles.headerDescription}>くじ1回毎に特別な景品が当たるチャンス！</div>}
      <div className={styles.headerWrapper}>
        <div className={styles.header}>
          <span className={montserrat.className}>W</span>チャンス賞
        </div>
      </div>
    </>
  );
}

export default WChanceCardHeader;
